import React from "react";
import { Box, Typography } from "@mui/material";
import { FUNNEL_COLORS } from "./chartTheme";

const ConversionFunnelChart = ({ funnel = [] }) => {
  const max = funnel[0]?.value || 1;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", gap: "10px", height: "100%" }}>
      {funnel.map((stage, i) => {
        const prev = funnel[i - 1]?.value;
        const dropPct = prev && prev > 0 ? Math.round((1 - stage.value / prev) * 100) : null;
        const widthPct = max > 0 ? Math.max((stage.value / max) * 100, 2) : 2;

        return (
          <Box key={stage.stage} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Typography sx={{ width: 72, flexShrink: 0, fontSize: 11.5, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "hsl(150, 18%, 28%)" }}>
              {stage.stage}
            </Typography>
            <Box sx={{ flex: 1, minWidth: 0, height: 24, backgroundColor: "hsl(140, 8%, 95%)", borderRadius: "6px", overflow: "hidden" }}>
              <Box
                sx={{
                  width: `${widthPct}%`,
                  height: "100%",
                  backgroundColor: FUNNEL_COLORS[i % FUNNEL_COLORS.length],
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  px: "8px",
                  boxSizing: "border-box",
                  transition: "width 0.6s cubic-bezier(.22,.61,.36,1)",
                }}
              >
                <Typography sx={{ fontSize: 12, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "#fff" }}>
                  {stage.value.toLocaleString()}
                </Typography>
              </Box>
            </Box>
            <Typography sx={{ width: 42, flexShrink: 0, textAlign: "right", fontSize: 11, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: dropPct ? "hsl(0, 60%, 50%)" : "hsl(150, 10%, 62%)" }}>
              {dropPct != null ? `${dropPct}%` : ""}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default ConversionFunnelChart;
